import { CheckCircle2, HelpCircle, MessageSquareText } from 'lucide-react';
import { PageHeader } from '@/components/shared/PageHeader';
import { Card } from '@/components/ui/card';
import { useTranslation } from '@/hooks/useTranslation';

const HIGHLIGHTS = [
  {
    icon: HelpCircle,
    titleKey: 'contact.intro.highlights.question.title',
    descriptionKey: 'contact.intro.highlights.question.description',
  },
  {
    icon: MessageSquareText,
    titleKey: 'contact.intro.highlights.bug.title',
    descriptionKey: 'contact.intro.highlights.bug.description',
  },
  {
    icon: CheckCircle2,
    titleKey: 'contact.intro.highlights.followUp.title',
    descriptionKey: 'contact.intro.highlights.followUp.description',
  },
] as const;

export function ContactIntro() {
  const { t } = useTranslation();

  return (
    <section className="space-y-4">
      <PageHeader
        label={{ text: t('contact.intro.badge') }}
        title={t('contact.intro.title')}
        description={t('contact.intro.description')}
      />

      <div className="grid gap-3 sm:grid-cols-2">
        {HIGHLIGHTS.map(({ icon: Icon, titleKey, descriptionKey }) => (
          <Card
            as="article"
            key={titleKey}
            padding="sm"
            className="flex h-full flex-col gap-2 text-left transition hover:-translate-y-0.5 hover:shadow-md"
          >
            <span className="flex size-8 items-center justify-center rounded-lg border border-border bg-muted text-primary">
              <Icon className="size-4" aria-hidden />
            </span>
            <div className="space-y-0.5">
              <h2 className="text-sm font-semibold text-foreground">{t(titleKey)}</h2>
              <p className="text-xs leading-relaxed text-muted-foreground">{t(descriptionKey)}</p>
            </div>
          </Card>
        ))}
      </div>
    </section>
  );
}
